import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_PAGES = "pages";
const BASE_URL = "/api/pages";

const PagesQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const PAGE_EMPTY = {title: "", description: "", alias: "", htmlFragment: ""};

export function usePages() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_PAGES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...PagesQueryConfig
    });
    return {...result, pages: result.data};
}


export function usePage(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_PAGES, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...PagesQueryConfig
    });
    return {...result, page: result.data};
}

export function usePagesMutations() {
    async function createFunction(page) {
        if (!page) return;
        return await fetchPOST(BASE_URL, page, false);
    }

    async function editFunction(page) {
        if (!page) return;
        return await fetchPUT(`${BASE_URL}/${page.id}`, page);
    }

    async function editAddNewFiles(page) {
        if (!page) return;
        return await fetchPUT(`${BASE_URL}/${page.id}/files`, page.filesIds);
    }

    async function deleteFunction(page) {
        return await fetchDELETE(`${BASE_URL}/${page.id}`)
    }

    return {
        createPage: useMyMutation(createFunction, REACT_QUERY_ID_PAGES, page => `Page ${page.title} created`),
        editPage: useMyMutation(editFunction, REACT_QUERY_ID_PAGES, page => `Page ${page.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_PAGES, page => `Page ${page.title} modified`),
        deletePage: useMyMutation(deleteFunction, REACT_QUERY_ID_PAGES, page => `Page ${page.title} deleted.`)
    };

}